import React from 'react';
import {
  FiMap,
  FiFileText,
  FiBook,
  FiMic,
  FiHeadphones,
  FiBookOpen,
  FiEdit2,
  FiActivity,
} from 'react-icons/fi';

/**
 * Standard categories for the English sidebar
 * Used across all English-related pages for consistent navigation
 */
export const ENGLISH_SIDEBAR_CATEGORIES = [
  { key: 'journey', label: 'My Journey', icon: <FiMap />, tag: 'New' },
  { key: 'divider0', type: 'separator' },
  { key: 'grammar', label: 'Grammar', icon: <FiFileText /> },
  { key: 'vocabulary', label: 'Vocabulary', icon: <FiBook /> },
  { key: 'divider1', type: 'separator' },
  { key: 'speaking', label: 'Speaking', icon: <FiMic /> },
  { key: 'listening', label: 'Listening', icon: <FiHeadphones /> },
  { key: 'reading', label: 'Reading', icon: <FiBookOpen /> },
  { key: 'writing', label: 'Writing', icon: <FiEdit2 /> },
  { key: 'divider2', type: 'separator' },
  { key: 'progression', label: 'My Progress', icon: <FiActivity /> },
];

/**
 * Get the category key from a URL path
 * @param {string} path - The current URL path
 * @returns {string} - The category key
 */
export const getCategoryFromPath = (path) => {
  if (path.includes('/journey')) return 'journey';
  if (path.includes('/grammar')) return 'grammar';
  if (path.includes('/vocabulary')) return 'vocabulary';
  if (path.includes('/speaking')) return 'speaking';
  if (path.includes('/listening')) return 'listening';
  if (path.includes('/reading')) return 'reading';
  if (path.includes('/writing')) return 'writing';
  if (path.includes('/progression') || path.includes('/progress'))
    return 'progression';
  return 'grammar'; // default
};

export default ENGLISH_SIDEBAR_CATEGORIES;
